<template>
  <div class="channel-avatar" :style="{ '--size': size }">
    <div class="channel-avatar-content">
      <component v-if="!isDefaultType" :is="getAvatar(id)" :style="{ width: size, height: size }" />
      <div v-else class="default-avatar-style" :style="{ '--bg-color': color }">
        <span>{{ name[0] }}</span>
      </div>
    </div>
    <div v-if="channel !== 1" class="channel-avatar-badge">
      <component :is="getChannel(channel)" :style="{ width: '10px', height: '10px' }" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, h, computed } from 'vue'
import AvatarImg from './AvatarImg.vue'
import ChannelImg from './ChannelImg.vue'
import { getImgUrl, getNumberFromUrl, uuidToNumber, getColorByKey } from '@/utils/getImgUrl'

export default defineComponent({
  name: 'ChannelAvatar',
  props: {
    id: {
      type: String,
      default: '1',
    },
    size: {
      type: String,
      default: '40px',
    },
    name: {
      type: String,
      default: 'Anonymous',
    },
    channel: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const isDefaultType = computed(() => props.id === null)

    const color = computed(() => {
      const key = uuidToNumber(props.name)
      return getColorByKey(key)
    })

    const getAvatar = (id: string) => {
      if (id === '' || id === null) {
        return h(AvatarImg, {
          avatar: getImgUrl(`avatar/avatar-1`, 'png'),
        })
      } else if (typeof id === 'number') {
        return h(AvatarImg, {
          avatar: getImgUrl(`avatar/avatar-${id}`, 'png'),
        })
      } else {
        return h(AvatarImg, {
          avatar: getNumberFromUrl(id as string),
        })
      }
    }

    const getChannel = (id: number) => {
      return h(ChannelImg, {
        avatar: id,
      })
    }

    return { color, isDefaultType, getAvatar, getChannel }
  },
})
</script>

<style lang="less" scoped>
.channel-avatar {
  position: relative;
  width: var(--size);
  height: var(--size);

  &-content {
    border-radius: 50%;
    overflow: hidden;
    width: var(--size);
    height: var(--size);
  }

  &-badge {
    position: absolute;
    display: flex;
    padding: 1px;
    background-color: white;
    border-radius: 50%;
    right: 0;
    bottom: 0;
    width: 12px;
    height: 12px;
  }
}

.default-avatar-style {
  display: grid;
  place-items: center;
  background-color: var(--bg-color);
  height: var(--size);
  width: var(--size);

  & > span {
    color: white;
    font-size: 20px;
    font-weight: 500;
  }
}
</style>
